import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import { SectionHeading, EmptyState } from 'components/Erp/Presentation';
import { ShieldCheck, Plus, Pencil, Save, X, ChevronLeft, ChevronRight } from 'lucide-react';
import React from 'react'
import { useSelector } from 'react-redux'
import { hasAccess } from 'utils/access'
import ResponsiveTable from './ResponsiveTable'
import AuditButton from './AuditButton'
import GuardAccountActions from './GuardAccountActions'
import GuardSyncStatus from './GuardSyncStatus'
import { StatusBadge } from 'components/Erp/Display'
import styles from '../AdminPanelPage.module.scss'

const GuardsPanel = ({
  guardsFilter,
  setGuardsFilter,
  filteredGuards,
  guardsPagination,
  loadGuardsPage,
  openCreateModal,
  startEdit,
  editingGuard,
  editPayloads,
  setEditPayloads,
  saveEdit,
  cancelEdit,
}) => {
  useInterfaceLanguage();
  const user = useSelector(state => state.user)
  const canEdit = !user?.is_report_only && hasAccess(user, 'guards')
  return (
    <div className={styles.panel}>
      <SectionHeading icon={ShieldCheck} title={tr("Охрана КПП")} actions={<><div className={styles.actionGroup}>
          {canEdit && <button className={styles.addButton} onClick={() => openCreateModal('guard')}><Plus size={14} aria-hidden="true"/>{tr(" Добавить охранника")}</button>}
        </div></>} />
      <div className={styles.panelBody}>
        <div className={styles.searchRow}>
          <input className={styles.searchInput} placeholder={tr("Поиск...")} value={guardsFilter} onChange={(e) => setGuardsFilter(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') loadGuardsPage(1, guardsFilter) }} />

        </div>
        {filteredGuards && filteredGuards.length ? (
          <ResponsiveTable className={styles.table}>
            <thead>
              <tr>
                <th>№</th>
                <th>{tr("Сотрудник")}</th>
                <th>{tr("Телефон")}</th>
                <th>{tr("Дополнительный ном.тел")}</th>
                <th>{tr("Статус")}</th>
                <th>{tr("Шлюз")}</th>
                <th>{tr("Действия")}</th>
              </tr>
            </thead>
            <tbody>
              {filteredGuards.map((g, index) => (
                <React.Fragment key={g.id}>
                  <tr>
                    <td>{tr(index + 1)}</td>
                    <td>{tr(g.employee_name || g.employee_name || `#${g.id}`)}</td>
                    <td>{tr(g.employee_phone || '-')}</td>
                    <td>{tr(g.phone || '-')}</td>
                    <td><StatusBadge tone={g.is_active ? 'success' : 'danger'}>{g.is_active ? tr("Активен") : tr("Неактивен")}</StatusBadge></td>
                    <td><GuardSyncStatus sync={g.integration_sync} /></td>
                    <td>
                      <div className={styles.actionGroup}>
                        {canEdit && <button className={`${styles.smallBtn} ${styles.editBtn}`} aria-expanded={editingGuard === g.id} onClick={() => { startEdit('guard', g.id, { phone: g.phone, is_active: g.is_active }) }}><Pencil size={14} aria-hidden="true"/>{tr(" Изменить")}</button>}
                        <GuardAccountActions guard={g} onChanged={() => loadGuardsPage(guardsPagination?.page || 1, guardsFilter || '')} />
                        <AuditButton section="guards" objectId={g.id} objectType="tabel.Guard"/>
                      </div>
                    </td>
                  </tr>
                  {tr(canEdit && editingGuard === g.id && (
                    <tr>
                      <td colSpan={7}>
                        <div style={{ padding: 8 }}>
                          <label>{tr("Телефон")}</label>
                          <input value={(editPayloads[`guard__${g.id}`] || {}).phone || ''} onChange={(e) => setEditPayloads(p => ({ ...p, [`guard__${g.id}`]: { ...p[`guard__${g.id}`], phone: e.target.value } }))} />
                          <label style={{ marginLeft: 8 }}>{tr("Активен")}</label>
                          <input type="checkbox" checked={(editPayloads[`guard__${g.id}`] || {}).is_active || false} onChange={(e) => setEditPayloads(p => ({ ...p, [`guard__${g.id}`]: { ...p[`guard__${g.id}`], is_active: e.target.checked } }))} />
                          <div className={styles.actionGroup} style={{ marginTop: 8 }}>
                            <button className={styles.btn_pin} onClick={() => saveEdit('guard', g.id)}><Save size={14} aria-hidden="true"/>{tr(" Сохранить")}</button>
                            <button className={styles.btn_pin_close} onClick={() => cancelEdit('guard', g.id)}><X size={14} aria-hidden="true"/>{tr(" Отмена")}</button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              ))}
            </tbody>
          </ResponsiveTable>
        ) : (
          <EmptyState icon={ShieldCheck} title={tr("Охранники не найдены")} description={tr("Добавьте сотрудника охраны или измените условия поиска.")} compact />
        )}
        {tr((!guardsFilter && guardsPagination && guardsPagination.count > 0) && (
          <div className={styles.pagination}>
            <button disabled={!guardsPagination.previous} onClick={() => loadGuardsPage((guardsPagination.page || 1) - 1)}><ChevronLeft size={14} aria-hidden="true"/>{tr(" Пред.")}</button>
            <span>{tr("Стр. ")}{tr(guardsPagination.page || 1)}{tr(" — Всего: ")}{tr(guardsPagination.count)}</span>
            <button disabled={!guardsPagination.next} onClick={() => loadGuardsPage((guardsPagination.page || 1) + 1)}><ChevronRight size={14} aria-hidden="true"/>{tr(" След.")}</button>
          </div>
        ))}
      </div>
    </div>
  )
}

export default GuardsPanel
